import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import {
  FlexLayout,
  AssigneeLabel,
  Button,
  CloseCircleIcon,
  OptionCard,
  PageHeader,
} from 'components'
import { useValueContext } from 'contexts'
import { ITaskPerson } from 'types'

import './styles.scss'

export const Assignee = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { taskStore, projectStore } = useValueContext()
  const { task, setTaskField } = taskStore
  const { enabledUsers } = projectStore

  const onSelect = (assignee: ITaskPerson | null) => {
    setTaskField('assignedTo', assignee)
    navigate(-1)
  }

  return (
    <FlexLayout.Container vertical>
      <PageHeader>{t('Исполнитель')}</PageHeader>
      <Button
        mode="plain"
        className="assignee-delete-btn"
        before={<CloseCircleIcon />}
        onClick={() => onSelect(null)}
      >
        {t('Удалить исполнителя')}
      </Button>
      <FlexLayout.Content className="scrollable-list" scrollable>
        {enabledUsers.map((x: ITaskPerson) => {
          return (
            <OptionCard
              key={x.id}
              className={cn('assignee-option', { selected: x.id === task?.assignedTo?.id })}
              onClick={() => onSelect(x)}
            >
              <AssigneeLabel data={x} />
            </OptionCard>
          )
        })}
      </FlexLayout.Content>
    </FlexLayout.Container>
  )
})
